import { Briefcase, CheckCircle } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";

const BusinessFormation = () => {
  const mainContent = (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold mb-6">Business Formation Services</h2>
          <p className="text-lg text-muted-foreground mb-12">
            Start your business right with proper legal structure and documentation.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {[
              { title: "LLC Formation", items: ["Single-member LLC", "Multi-member LLC", "Operating agreements", "EIN application"] },
              { title: "Corporation Setup", items: ["C-Corporation", "S-Corporation", "Bylaws and articles", "Stock certificates"] },
              { title: "Partnerships", items: ["General partnerships", "Limited partnerships", "Partnership agreements", "Buy-sell agreements"] },
              { title: "Non-Profit", items: ["501(c)(3) formation", "Tax-exempt status", "Board governance", "Compliance"] }
            ].map((service, idx) => (
              <div key={idx} className="bg-card p-8 rounded-lg border border-accent/20">
                <h3 className="text-2xl font-bold mb-4">{service.title}</h3>
                <ul className="space-y-2">
                  {service.items.map((item, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <CheckCircle className="h-5 w-5 text-accent flex-shrink-0 mt-0.5" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );

  const aiKeyPoints = [
    "LLC, Corporation, Partnership, and Non-Profit formation in Texas",
    "Complete operating agreements and bylaws drafting",
    "EIN application and tax registration assistance",
    "Name reservation and Secretary of State filings",
    "Liability protection setup for business owners",
    "Trilingual service: English, Spanish, Vietnamese"
  ];

  const aiFaqs = [
    {
      question: "What type of business entity should I form in Texas?",
      answer: "The best structure depends on your goals. LLCs offer flexibility and liability protection with pass-through taxation. Corporations are better for investors and going public. Partnerships work well for professional practices. We help you choose the optimal structure."
    },
    {
      question: "How long does business formation take in Texas?",
      answer: "Filing with the Texas Secretary of State typically takes 2-5 business days. Expedited processing is available for 24-hour turnaround. Complete setup including EIN, operating agreement, and compliance documents takes about 1-2 weeks."
    },
    {
      question: "What documents do I need to form an LLC in Texas?",
      answer: "You need a Certificate of Formation filed with the Secretary of State, an Operating Agreement (strongly recommended), EIN from the IRS, and initial compliance documents. We prepare all necessary documents as part of our formation services."
    }
  ];

  return (
    <GenericPracticePage 
      title="Business Formation" 
      subtitle="Establish Your Business with the Right Legal Structure" 
      icon={<Briefcase className="h-16 w-16" />} 
      mainContent={mainContent}
      category="business"
      aiKeyPoints={aiKeyPoints}
      aiFaqs={aiFaqs}
      aiServiceDescription="Expert business formation services in Houston, Texas for LLCs, corporations, partnerships, and non-profits. We handle all filings, operating agreements, and compliance setup."
    />
  );
};

export default BusinessFormation;